import { Layout } from 'antd';
import styled from 'styled-components';

const { Content } = Layout;

const ContentWrapper = styled(Content)`
  background-color: #f5f5f5;
`;

export default ContentWrapper;
